import produce from 'immer';

import { Types, pesquisaEnderecosRecebimento } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: pesquisaEnderecosRecebimento = {
	status: 0,
	data: null,
};

export default function pesquisaEnderecosRecebimentoReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): pesquisaEnderecosRecebimento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PESQUISA_ENDERECO_RECEBIMENTO_REQUEST: {
				break;
			}
			case Types.PESQUISA_ENDERECO_RECEBIMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.PESQUISA_ENDERECO_RECEBIMENTO_FAILURE: {
				break;
			}
			case Types.PESQUISA_ENDERECO_RECEBIMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
